import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { ExtraWorkOrdersApiAdapter } from '../adapters';
import { ExtraWorkOrder } from '../models';

export const useExtraWorkOrderDetail = (orderId: number | null) => {
  const httpClient = createHttpClient(apiClientWH);
  const apiAdapter = new ExtraWorkOrdersApiAdapter(httpClient);

  const {
    data: order,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['extra-work-order', orderId],
    queryFn: () => {
      if (!orderId) throw new Error('Order ID is required');
      return apiAdapter.getExtraWorkOrderById(orderId);
    },
    enabled: !!orderId,
    staleTime: 30 * 1000, // 30 segundos
  });

  return {
    order: order || null,
    isLoading,
    error,
    refetch,
  };
};
